export default __webpack_public_path__ + "amex-header-logo.png";